'use client';
import { IRepository } from '@/types';
import { Row } from '@/ui/primatives';
import Button from '@/ui/Button';
import * as Icon from '@/ui/Icon';
import useOxenSession from '@/hooks/useOxenSession';
import * as format from '@/lib/format';

const MAX_FORKABLE_REPO_SIZE_IN_BYTES = 5 * 1000 * 1000 * 1000;

const ForkButton: React.FC<{ repository: IRepository; hideMobile?: boolean }> = ({ repository, hideMobile }) => {
  const { authorization, config } = useOxenSession();
  const isForkingEnabled = !!config?.forking_enabled;

  if (!isForkingEnabled) {
    return null;
  }
  const isRepoTooLarge = repository.size > MAX_FORKABLE_REPO_SIZE_IN_BYTES;
  const isGatedRepo = repository.visibility === 'gated';
  const userCanFork = authorization.forRepository(repository).canFork();

  // TODO: Make ths generic so it can be used for other elements with the same behavior
  const tooltipContent = () => {
    if (!authorization.isLoggedIn()) {
      return 'You must be signed in to fork a dataset';
    }
    if (isGatedRepo && !userCanFork) {
      return 'You must accept the gated access policy to fork a dataset';
    }
    if (isRepoTooLarge) {
      return `Forking is temporarily disabled for repositories larger than ${format.humanFileSize(MAX_FORKABLE_REPO_SIZE_IN_BYTES)}`;
    }
    return undefined;
  };

  const isDisabled = !authorization.isLoggedIn() || !userCanFork || isRepoTooLarge;
  return (
    <Button.Basic
      tooltip={tooltipContent()}
      href={`/${repository.namespace}/${repository.name}/fork`}
      disabled={isDisabled}
      nowrap
      small
      style={{ padding: '5px 15px 5px 15px' }}
      hideMobile={hideMobile}
    >
      <Row gap={10} alignItems="center">
        <Icon.Fork size="12px" />
        <span>Fork</span>
      </Row>
    </Button.Basic>
  );
};

export default ForkButton;
